import React from 'react';
import { cn } from '../classname';
import { ToolbarButton } from './ToolbarButton';
import { ToolbarListButton } from './ToolbarListButton';
import { ToolbarDataType } from './types';
import './ToolbarGroup.css';
const b = cn('toolbar-group');
export function ToolbarButtonGroup({ className, editor, data, focus, onClick, }) {
    return (React.createElement("div", { className: b(null, [className]) }, data.map((item) => {
        if (item.type === ToolbarDataType.SingleButton) {
            return (React.createElement(ToolbarButton, Object.assign({}, item, { key: item.id, editor: editor, focus: focus, onClick: onClick, className: b(item.type, { id: item.id }, [item.className]) })));
        }
        if (item.type === ToolbarDataType.ListButton) {
            return (React.createElement(ToolbarListButton, Object.assign({}, item, { key: item.id, editor: editor, focus: focus, onClick: onClick, className: b(item.type, { id: item.id }, [item.className]) })));
        }
        if (item.type === ToolbarDataType.ReactComponent) {
            const Component = item.component;
            return (React.createElement(Component, { key: item.id, editor: editor, focus: focus, onClick: onClick, className: b(item.type, { id: item.id }, [item.className]) }));
        }
        if (item.type === ToolbarDataType.ReactNode) {
            return React.createElement(React.Fragment, { key: item.id }, item.content);
        }
        if (item.type === ToolbarDataType.ReactNodeFn) {
            return React.createElement(React.Fragment, { key: item.id }, item.content(editor));
        }
        return null;
    })));
}
